import {RegulationBase, RegulationPreset} from '../regulation-base';
import {ILauncherServiceFactory} from '../../launcher-service-factory.interface';
import {GERMANY_PRESETS_VALUES} from './germany-presets';
import {IPreset} from '../../presets/preset.interface';

export class Germany extends RegulationBase {
    constructor(services: ILauncherServiceFactory) {
        super(12, 'Germany', services);
    }

    getPresets(): IPreset[] {
        return [
            new RegulationPreset(this.name, GERMANY_PRESETS_VALUES, this.services)
        ];
    }
}